import dynamic from 'next/dynamic'
import { type FC } from 'react'

import { Loading } from '../../../../loading'
import { useProductPageContext } from '../../../components/productPageContext'

const CustomerJourneyContent = dynamic(
  async () =>
    import('./ProductPageNowJourneyDialogContent').then(
      (mod) => mod.ProductPageNowJourneyDialogContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)

const DefaultProductPageNowDialogContent = dynamic(
  async () =>
    import('./ProductPageNowDialogContent').then(
      (mod) => mod.ProductPageNowDialogContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)

export const ProductPageNowDialogDynamicContent: FC = () => {
  const { nowDetails } = useProductPageContext()

  if (nowDetails.nowCustomerJourneyEnabled) {
    return <CustomerJourneyContent />
  }

  return <DefaultProductPageNowDialogContent />
}
